import { Navigate, Route, Routes } from 'react-router-dom';

import { UserManage } from './UserManage';

export const UserRoutes = () => {
  return (
    <Routes>
      <Route path="manage" element={<UserManage />}></Route>

      <Route path="*" element={<Navigate to="/admin/home" />}></Route>
    </Routes>
  );
};
